<template>
  <v-dialog v-model="previewProgressDialog" persistent>
    <v-card>
      <v-card-title
        class="headline lighten-2 justify-content-between"
        primary-title
      >
        Preview Progress
        <v-btn
          @click="togglePreviewProgressDialog"
          color="error"
          class="float-right"
          text
        >
          <v-icon x-small>fas fa-times m-1</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <GChart
          type="ColumnChart"
          :data="chartData"
          :options="progressOptions"
          :settings="{ packages: ['bar'] }"
          :createChart="(el, google) => new google.charts.Bar(el)"
          class="mr-5"
        />

        <v-row class="mt-5">
          <v-col class="text-center" style="border-right: 2px solid #f9b417">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <h1
                  v-on="on"
                  class="interactive"
                  @click="toggleUnits('completed')"
                >
                  {{ progress.completedUnits.length }} of
                  {{ progress.totalCount }} Units Completed
                </h1>
              </template>
              <span>Click to Preview Units</span>
            </v-tooltip>
          </v-col>
          <v-col class="text-center" style="border-right: 2px solid #f9b417">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <h1
                  v-on="on"
                  class="interactive"
                  @click="toggleUnits('watched')"
                >
                  {{ progress.watchedUnits.length }} of
                  {{ progress.totalCount }} Watched Videos
                </h1>
              </template>
              <span>Click to Preview Units</span>
            </v-tooltip>
          </v-col>
          <v-col class="text-center">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <h1
                  v-on="on"
                  class="interactive"
                  @click="toggleUnits('outstanding')"
                >
                  {{ progress.outstandingUnits.length }} Outstanding Units
                </h1>
              </template>
              <span>Click to Preview Units</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="togglePreviewProgressDialog">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
    <preview-units-dialog
      :module-id="moduleId"
      :units="activeUnits"
      :preview-unit-dialog="previewUnitsDialog"
      :toggle-preview-dialog="togglePreviewUnitsDialog"
      :is-module-page="isModulePage"
    />
  </v-dialog>
</template>

<script>
import PreviewUnitsDialog from '@/components/course-certification/includes/PreviewUnitsDialog';

export default {
  name: 'PreviewProgressDialog',
  components: { PreviewUnitsDialog },
  props: {
    moduleId: Number,
    progress: Array,
    previewProgressDialog: Boolean,
    togglePreviewProgressDialog: Function,
    isModulePage: Boolean,
  },
  data() {
    return {
      activeUnits: [],
      previewUnitsDialog: false,
      progressOptions: {
        bars: 'vertical',
        hAxis: { format: 'decimal' },
        height: 400,
        colors: ['#f9b417'],
      },
    };
  },
  computed: {
    chartData() {
      return [
        ['', 'Units Completed', 'Watched Videos', 'Outstanding Units'],
        [
          ' ',
          this.progress.completedUnits.length,
          this.progress.watchedUnits.length,
          this.progress.outstandingUnits.length,
        ],
      ];
    },
  },
  methods: {
    toggleUnits(type) {
      if (type == 'completed') {
        this.activeUnits = this.progress.completedUnits;
      }
      if (type == 'watched') {
        this.activeUnits = this.progress.watchedUnits;
      }
      if (type == 'outstanding') {
        this.activeUnits = this.progress.outstandingUnits;
      }

      this.togglePreviewUnitsDialog();
    },
    togglePreviewUnitsDialog() {
      this.previewUnitsDialog = !this.previewUnitsDialog;
    },
  },
};
</script>

<style scoped>
.interactive {
  cursor: pointer;
}
</style>
